import { FC } from 'react';

import { useRegistrationStore } from 'page/CustomerPage/hooks';
import { ResultModalView } from 'page/CustomerPage/components/RegistrationModal/ResultModalView';

type Props = {
  handleClose: () => void;
};

export const ResultModal: FC<Props> = ({ handleClose }) => {
  const { loading, isOpenResultModal, name, token, hasError } =
    useRegistrationStore();

  return (
    <>
      {/* 結果モーダル */}
      <ResultModalView
        mode="登録"
        loading={loading}
        isOpen={isOpenResultModal}
        name={name}
        zeusToken={token}
        hasError={hasError}
        handleClose={handleClose}
      />
    </>
  );
};
